import { z } from 'zod';
import { segmentDefinitionSchema } from './segmentDefinition.js';
export const AUDIENCE_STATUSES = ['draft', 'active', 'archived'];
export const AUDIENCE_TYPES = ['static', 'dynamic'];
export const AUDIENCE_MEMBER_SOURCES = ['manual', 'rule', 'scraper', 'import'];
export const AUDIENCE_STATUS_LABELS = {
    draft: 'Concept',
    active: 'Actief',
    archived: 'Gearchiveerd',
};
export const audienceCreateSchema = z.object({
    project_id: z.string().uuid(),
    name: z.string().min(1).max(200),
    description: z.string().max(5000).optional().nullable(),
    status: z.enum(AUDIENCE_STATUSES).default('draft'),
    audience_type: z.enum(AUDIENCE_TYPES).default('static'),
});
export const audienceUpdateSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    description: z.string().max(5000).optional().nullable(),
    status: z.enum(AUDIENCE_STATUSES).optional(),
    audience_type: z.enum(AUDIENCE_TYPES).optional(),
    segment_definition: segmentDefinitionSchema.nullable().optional(),
    refresh_enabled: z.boolean().optional(),
    refresh_remove_non_matching: z.boolean().optional(),
});
export const audiencesListQuerySchema = z.object({
    project_id: z.string().uuid(),
    status: z.enum(AUDIENCE_STATUSES).optional(),
});
export const audienceMembersSchema = z.object({
    lead_ids: z.array(z.string().uuid()).min(1).max(5000),
    source: z.enum(AUDIENCE_MEMBER_SOURCES).default('manual'),
});
export const audienceAccountsSchema = z.object({
    account_ids: z.array(z.string().uuid()).min(1).max(500),
    source: z.enum(AUDIENCE_MEMBER_SOURCES).default('manual'),
});
export const audienceAttachCandidatesSchema = z.object({
    candidate_ids: z.array(z.string().uuid()).min(1).max(500),
});
//# sourceMappingURL=audience.js.map